export namespace Assets {
  export const images = {
    avatar: "https://assets.iyk.app/jessie-reyez/avatar.webp",
    og: "https://assets.iyk.app/jessie-reyez/og_image.png",
    logo: "https://assets.iyk.app/jessie-reyez/app_logo.webp",
    layoutBackground: "https://assets.iyk.app/jessie-reyez/profile_background.webp",
    sidebarLogo: "https://assets.iyk-dev.app/jessie-reyez/jessie-reyez-icon.webp",
    profileBackground: "https://assets.iyk.app/jessie-reyez/profile_background.webp",
    emptyCollectionBackground: "https://assets.iyk.app/jessie-reyez/profile_background.webp",
    // The enable location images object is globally used across all apps.
    // They are not specific to Disturbed, is just that Disturbed was the first app to use them.
    // So it's ok to keep using the disturbed bucket for now.
    enableLocation: {
      ios: {
        step1: "https://assets.iyk.app/disturbed/check-in/enable_location_ios_1.png",
        step2: "https://assets.iyk.app/disturbed/check-in/enable_location_ios_2.png",
      },
      android: {
        step1: "https://assets.iyk.app/disturbed/check-in/enable_location_android.png",
      },
    },
    email: {
      logo: "https://assets.iyk.app/jessie-reyez/app_logo_dark.png",
    },
    rouletteBaseUrl: "https://assets.iyk.app/iyk/roulette",
  }

  export const videos = {
    marquee: "https://assets.iyk.app/disturbed/merch/disturbed-marquee-video.mp4",
  }

  export const documents = {
    rules: "https://assets.iyk.app/jessie-reyez/IYK-Jessie-Reyez-Official-Rules.pdf",
    privacyPolicy: "https://assets.iyk.app/iyk-privacy-policy.pdf",
    termsOfService: "https://assets.iyk.app/iyk-terms-of-service.pdf",
    artistsPrivacyPolicy: "https://privacy.umusic.com",
  }
}
